(function() {
  'use strict';

  function ModalExcluirEnderecoController($uibModalInstance, deletarEndereco, idItem) {

    var modalExcluir = this;

    modalExcluir.back = function() {
      $uibModalInstance.dismiss('cancel');
    };

    modalExcluir.deleteConfirm = function() {
      deletarEndereco = true;
      var objExcluir = {
        deletarEndereco: true,
        id: idItem
      }
      $uibModalInstance.close(objExcluir);
    };

  };

  angular
    .module('mandaeApp')
    .controller('ModalExcluirEnderecoController', ModalExcluirEnderecoController);
})();
